export interface RegistrationQuestionsOption {
  value: string;
  label: string;
}

export const met_conlicitacao: RegistrationQuestionsOption[] = [
  {
    value: 'Já fui assinante',
    label: 'Já fui assinante',
  },
  {
    value: 'Indicação',
    label: 'Indicação',
  },
  {
    value: 'Evento',
    label: 'Evento',
  },
  {
    value: 'E-mail',
    label: 'E-mail',
  },
  {
    value: 'Google',
    label: 'Google',
  },
  {
    value: 'Instagram',
    label: 'Instagram',
  },
  {
    value: 'Youtube',
    label: 'Youtube',
  },
  {
    value: 'LinkedIn',
    label: 'LinkedIn',
  },
  {
    value: 'Outros',
    label: 'Outros',
  },
];

export const billing: RegistrationQuestionsOption[] = [
  {
    value: 'Ainda não faturo com licitações',
    label: 'Ainda não faturo com licitações',
  },
  {
    value: 'Até R$ 100 mil',
    label: 'Até R$ 100 mil',
  },
  {
    value: 'de R$ 100 mil a 500 mil',
    label: 'de R$ 100 mil a 500 mil',
  },
  {
    value: 'De R$ 500 mil a R$ 1 milhão',
    label: 'De R$ 500 mil a R$ 1 milhão',
  },
  {
    value: 'De R$ 1 milhão a R$ 10 milhões',
    label: 'De R$ 1 milhão a R$ 10 milhões',
  },
  {
    value: 'Mais de R$ 10 milhões',
    label: 'Mais de R$ 10 milhões',
  },
];

export const description_services_conlicitacao: RegistrationQuestionsOption[] = [
  {
    value: 'Aprender a licitar',
    label: 'Aprender a licitar',
  },
  {
    value: 'Representar clientes',
    label: 'Representar clientes',
  },
  {
    value: 'Otimizar resultados',
    label: 'Otimizar resultados',
  },
  {
    value: 'Outros',
    label: 'Outros',
  },
];

export const average_participation_bidding: RegistrationQuestionsOption[] = [
  {
    value: 'Não participo',
    label: 'Não participo',
  },
  {
    value: '1 - 5',
    label: '1 - 5',
  },
  {
    value: '6 - 10',
    label: '6 - 10',
  },
  {
    value: 'Mais de 10',
    label: 'Mais de 10',
  },
];

export const employee_quantity: RegistrationQuestionsOption[] = [
  {
    value: 'até 2',
    label: 'até 2',
  },
  {
    value: '3 - 9',
    label: '3 - 9',
  },
  {
    value: '10 - 49',
    label: '10 - 49',
  },
  {
    value: '50 - 100',
    label: '50 - 100',
  },
  {
    value: 'Mais de 100',
    label: 'Mais de 100',
  },
];
